import React from 'react'
import {
  Box,
  Button,
  Heading,
  HStack,
  Skeleton,
  SkeletonText,
  Text,
} from '@chakra-ui/react'

const defaultImage =
  'https://res.cloudinary.com/dcatzxqqf/image/upload/v1739750665/galileo/helpcenter/circle-helpcenter_r4xpvh.png'

export type HeaderTipsProps = {
  title?: string
  description?: string
  labelButton?: string
  isLoading?: boolean
  image?: string
  slug: string
  onClick: (slug: string) => void
}

export const HeaderTips = ({
  title = '',
  description = '',
  labelButton = '',
  isLoading = true,
  image = defaultImage,
  slug = '',
  onClick,
  ...props
}: HeaderTipsProps) => {
  const hasData = !isLoading && title && description && slug

  return (
    <Box
      minHeight={'308px'}
      width={'100%'}
      userSelect={'none'}
      bg='#171717'
      borderRadius={'6px'}
      borderColor={'#313131'}
      borderWidth={1}
      borderLeftWidth={5}
      p={4}
      backgroundImage={image}
      backgroundRepeat={'no-repeat'}
      backgroundPosition={'right'}
      {...props}
    >
      <HStack
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'flex-start'}
        flexDirection={'column'}
        pt={4}
        pl={5}
        pr={5}
        pb={4}
        gap={4}
        maxWidth={{
          md: '100%',
          lg: '85%',
          xl: '70%',
        }}
        height={'100%'}
      >
        <SkeletonText
          isLoaded={!isLoading}
          noOfLines={7}
          spacing='2'
          skeletonHeight='3'
          width='100%'
        >
          <Heading color='white' size='lg' pb={4} textShadow='0 0 12px #000000'>
            {hasData ? title : 'Artículo no disponible'}
          </Heading>
          <Text
            as='p'
            color='#ffffff99'
            fontSize={'sm'}
            pb={2}
            lineHeight={'150%'}
            textShadow='0 3px 12px #000000'
          >
            {description}
          </Text>
        </SkeletonText>

        <Skeleton isLoaded={!isLoading} width={isLoading ? '200px' : 'auto'}>
          <Button
            opacity={0.8}
            bgColor='#020202'
            fontSize={'14px'}
            fontWeight={500}
            animation={'ease-in-out'}
            _hover={hasData ? { opacity: 1 } : {}}
            cursor={'pointer'}
            type='button'
            paddingX={35}
            variant='solid'
            disabled={!hasData}
            onClick={() => onClick(slug)}
          >
            {labelButton}
          </Button>
        </Skeleton>
      </HStack>
    </Box>
  )
}
